export const LOAD_ORGANIZER = 'LOAD_ORGANIZER';
export const LOAD_PAYMENTS = 'LOAD_PAYMENTS';
export const PERSIST_ORGANIZER = 'PERSIST_ORGANIZER';
export const PAYMENTS_TABLE_WIDTH = '1610px';
export const FOOTER_AND_HEADER_HEIGHT = '284px';
